import moment from 'moment';

export default class NumbersUtil {
    static isANumber(number: number) {
        if (number === undefined || number === null) return false;
        else return (!isNaN(number));
    }

    static toDuration(ms: number) {
        let duration = moment.duration(ms);

        let seconds = NumbersUtil.prependZeroToDuration(duration.seconds());
        let minutes = NumbersUtil.prependZeroToDuration(duration.minutes());
        let hours = NumbersUtil.prependZeroToDuration(duration.hours());

        return `${hours}:${minutes}:${seconds}`;
    }

    static prependZeroToDuration(number: number) {
        if (number < 10 && number > -10) return `0${number.toString()}`;
        else return number.toString();
    }

    static toDurationPretty(ms: number) {
        let dur = moment.duration(ms);
        let hours = dur.hours();
        let minutes = dur.minutes();
        let seconds = dur.seconds();

        let str = '';
        if (hours) str += `${hours}h `;
        if (minutes || hours) str += `${minutes}m `;
        str += `${seconds}s`;

        return str;
    }

    static toShortened(num, digits) {
        if (num < 1000){
            return num.toFixed(digits);
        }
        const lookup = [
            {value: 1, symbol: ""},
            {value: 1e3, symbol: "K"},
            {value: 1e6, symbol: "M"},
            {value: 1e9, symbol: "B"},
            {value: 1e12, symbol: "T"},
            {value: 1e15, symbol: "P"},
            {value: 1e18, symbol: "E"}
        ];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        let item = lookup.slice().reverse().find(function (item) {
            return num >= item.value;
        });
        return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    }
}